import { render } from "./Perkhidmatan.vue?vue&type=template&id=2597728c"
import script from "./Perkhidmatan.vue?vue&type=script&lang=js"
export * from "./Perkhidmatan.vue?vue&type=script&lang=js"

import "./Perkhidmatan.vue?vue&type=style&index=0&id=2597728c&lang=css"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__